/* istanbul ignore file */

export const CLOSE_TIMEOUT_MS = process.env.NODE_ENV === 'test' ? 0 : 250;
